import type { IChatItem } from './chat';

/**
 * Entrada del índice de conversaciones. Es lo único que se necesita para
 * pintar la lista del historial, sin tener que bajar cada hilo completo.
 */
export interface ChatSummary {
  /** Uuid de la conversación, es la segunda parte de la llave del storage */
  id: string;
  /** Nombre visible del chat. Se deduce del primer mensaje y se puede renombrar */
  title: string;
  /** Fecha de creación, en ISO */
  createdAt: string;
  /** Fecha del último mensaje, en ISO. Ordena la lista */
  updatedAt: string;
  /** Primeras palabras del último mensaje, para el subtítulo de la lista */
  preview?: string;
  /** Cantidad de mensajes del hilo */
  messageCount?: number;
}

/**
 * Índice del usuario. El controlador de storage solo expone get y set por
 * llave, así que la lista de conversaciones se mantiene en su propio blob.
 */
export interface ChatHistoryIndex {
  chats: ChatSummary[];
  /** Última conversación abierta, para reabrirla al volver al chat */
  lastActiveId?: string | null;
}

/**
 * Hilo completo tal como se guarda en el storage, en la llave `email/uuid`.
 */
export interface StoredChat {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  /** Conversación viva en el agente */
  conversationId: string | null;
  /** Sesión que el agente arrastra entre turnos */
  session: string | null;
  /**
   * Despliegue del agente donde vive `conversationId` (ver ChatAgentService).
   * Los hilos anteriores al selector no lo traen.
   */
  agent?: string;
  messages: IChatItem[];
  /** Marca de baja: el controlador no expone delete, la llave se sobrescribe */
  deleted?: boolean;
}

/**
 * Grupo de conversaciones por antigüedad, tal como se pinta en el panel.
 */
export interface ChatHistoryGroup {
  label: string;
  chats: ChatSummary[];
}
